module.exports = __webpack_public_path__ + "img/preview-icon.ef641f2b.svg";